module.exports = "/fonts/fa-brands-400.svg?5c2d83d411cb3a620642748047b0a78f";